import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import { useFormState, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CustomTemplateWithLocales } from 'models/automation/CustomTemplates';
import Button from 'components/button/Button';
// import AutoTranslateButton from './AutoTranslateButton';
import { UPDATE_TEMPLATE_SETTINGS_MUTATION_KEY } from 'components/domain/automation/useUpdateTemplateSettingsMutation';
import { useIsMutating } from '@tanstack/react-query';
import useDeleteCustomTemplateModal from './delete/useDeleteCustomTemplateModal';
import { CUSTOM_TEMPLATE_ADD_EDIT_MODAL_ID } from './CustomTemplateAddEditModal.constants';
import { CustomTemplateAddEditModalFooterStyled } from './CustomTemplateAddEditModal.styles';

const CustomTemplateAddEditModalFooter = ({
  closeModal,
  customTemplate,
}: {
  closeModal: () => void;
  customTemplate: CustomTemplateWithLocales | undefined;
}) => {
  const { openDeleteCustomTemplateModal } = useDeleteCustomTemplateModal({
    closeAdditionalModals: [CUSTOM_TEMPLATE_ADD_EDIT_MODAL_ID],
  });
  const { t } = useTranslation();
  const { isSubmitting, dirtyFields } = useFormState();
  const isUpdatingTemplateSettings =
    useIsMutating({ mutationKey: [UPDATE_TEMPLATE_SETTINGS_MUTATION_KEY] }) > 0;

  const isEditMode = !!customTemplate?.uid;
  const isAutoTranslate = useWatch({ name: 'autoTranslate' });

  return (
    <CustomTemplateAddEditModalFooterStyled>
      {isEditMode && (
        <Button
          data-testid="delete-custom-template-modal-button"
          bsStyle="danger"
          className="float-left"
          onClick={() => openDeleteCustomTemplateModal(customTemplate)}
        >
          {t('common.delete')}
        </Button>
      )}
      <ModalFormCancelButton closeOnClick={false} onClick={closeModal} />
      {/* {isEditMode && <AutoTranslateButton />} */}
      <ModalFormSubmitButton
        disabled={
          Object.keys(dirtyFields).length === 0 ||
          isSubmitting ||
          isUpdatingTemplateSettings
        }
      >
        {isSubmitting
          ? t('common.saving')
          : t(
              `pageAutomations.customTemplates.modal.save_${
                isAutoTranslate ? 'autoTranslate' : 'noAutoTranslate'
              }`,
            )}
      </ModalFormSubmitButton>
    </CustomTemplateAddEditModalFooterStyled>
  );
};

export default CustomTemplateAddEditModalFooter;
